import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ViewMoreDialogData } from '@data-access/submissions/types';
import { WcgDialogModule, ButtonDirective } from '@wcg/frontend-framework';
import { ERMDateTimePipe } from '@shared/pipes/erm-date.pipe';

@Component({
  selector: 'wcg-view-more-dates-dialog',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatDialogModule,
    WcgDialogModule,
    MatButtonModule,
    ButtonDirective,
    ERMDateTimePipe,
  ],
  templateUrl: './view-more-dates-dialog.component.html',
  styleUrl: './view-more-dates-dialog.component.scss',
})
export class ViewMoreDatesDialogComponent {
  public readonly dialogData: ViewMoreDialogData = inject(MAT_DIALOG_DATA);
}
